import React from 'react';
import classNames from 'classnames';

import { Skeleton } from '@ui/Skeleton';

import s from './Stars.sss';

interface Props {
  className?: string;
}

export const StarsSkeleton: React.FC<Props> = ({
  className,
}) => (
  <ul className={classNames(
    s.list,
    className,
  )}
  >
    {[...Array(5)].map((_, i) => (
      <li
        key={i}
        className={s.item}
      >
        <Skeleton
          type="circle"
          width="16px"
          height="16px"
        />
      </li>
    ))}
  </ul>
);
